<template>
  <div id="mision">
    <section class="pantalla">
      <div class="mision">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="botonera text-left">
              <div class="planeta abs">
                <img
                  data-aos="fade-right"
                  data-aos-delay="800"
                  src="../../../assets/imgs/mision/3/planeta.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div
                  class="fpG2 border-bottom-azul pb3 w80 mtn11"
                  data-aos="fade"
                  data-aos-delay="1200"
                >
                  <strong class="azulicono bold">NIVEL 0{{mision}} - PLANETA </strong
                  ><br />
                  <span class="azulicono bold">TELLUS - Sector Beta</span>
                </div>
                <div
                  class="fpXG border-bottom-azul py3 w80"
                  data-aos="fade"
                  data-aos-delay="1200"
                >
                  <strong class="azul bold"> Objetivo</strong><br />
                  <span class="azul bold">Desarrollo</span><br />
                  <span class="azul bold">Planeta Tierra</span>
                </div>
                <div
                  class="w-100 pt-2 objetivo"
                  data-aos="fade"
                  data-aos-delay="1200"
                >
                  <img
                    src="../../../assets/imgs/mision/bg-objetivo.png"
                    alt="Encauce"
                    class="img-fluid"
                  />
                  <div class="texto blanco">
                    <p class="fpR2 m-0">
                      {{ extracto }}
                    </p>
                    <span class="btn-mas fpR" @click="toggleInfo">
                      LEER MÁS
                      <span class="flecha">
                        <svg
                          viewBox="0 0 1792 1792"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill="#ffffff"
                            d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
                          />
                        </svg>

                        <span class="flecha">
                          <svg
                            height="1792"
                            viewBox="0 0 1792 1792"
                            width="1792"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fill="#ffffff"
                              d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
                            />
                          </svg>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <div class="holograma" data-aos="fade" data-aos-delay="400">
                <img
                  src="../../../assets/imgs/mision/holograma.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="info d-flex flex-column">
                  <div>
                    <img
                      src="../../../assets/imgs/mision/4/icono.png"
                      alt="Encauce"
                      class="img-fluid icono noevents"
                    />
                  </div>
                  <div class="texto blanco pb5 noevents">
                    <strong>Selecciona una de las bases interestaleres</strong>,
                    donde te gustaría colaborar.
                  </div>
                  <div>
                    <img
                      @click="avanzar"
                      src="../../../assets/imgs/mision/btn-go.png"
                      alt="Encauce"
                      class="img-fluid boton btnhover"
                    />
                  </div>
                </div>

                <div class="opciones" v-if="avance.misiones.length > 0">
                  <div
                    :class="{
                      active: avance.misiones[mision - 1].reto >= 1,
                      noevents: avance.misiones[mision - 1].reto < 1,
                      selected: selected == 1,
                    }"
                    class="opcion opcion-1 active d-flex flex-row justify-content-center align-items-center"
                  >
                    <div class="bullet">
                      <img
                        src="../../../assets/imgs/mision/bullet.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div class="reto" @click="selecciona(1)">
                      <img
                        src="../../../assets/imgs/mision/back-btn-menu-2.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                      <div
                        class="desc d-flex justify-content-start align-items-center"
                      >
                        <div class="icono">
                          <img
                            src="../../../assets/imgs/mision/4/icono-1.png"
                            alt="Encauce"
                            class="img-fluid"
                          />
                        </div>
                        <div class="texto bold fpG blanco">
                          CONOCIMIENTO <br />01
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      active: avance.misiones[mision - 1].reto >= 2,
                      noevents: avance.misiones[mision - 1].reto < 2,
                      selected: selected == 2,
                    }"
                    class="opcion opcion-2 d-flex flex-row justify-content-center align-items-center"
                  >
                    <div class="bullet">
                      <img
                        src="../../../assets/imgs/mision/bullet.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div class="reto" @click="selecciona(2)">
                      <img
                        src="../../../assets/imgs/mision/back-btn-menu-2.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                      <div
                        class="desc d-flex justify-content-start align-items-center"
                      >
                        <div class="icono">
                          <img
                            src="../../../assets/imgs/mision/4/icono-2.png"
                            alt="Encauce"
                            class="img-fluid"
                          />
                        </div>
                        <div class="texto bold fpG blanco">
                          CONOCIMIENTO <br />02
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      active: avance.misiones[mision - 1].reto >= 3,
                      noevents: avance.misiones[mision - 1].reto < 3,
                      selected: selected == 3,
                    }"
                    class="opcion opcion-3 d-flex flex-row justify-content-center align-items-center"
                  >
                    <div class="bullet">
                      <img
                        src="../../../assets/imgs/mision/bullet.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div class="reto" @click="selecciona(3)">
                      <img
                        src="../../../assets/imgs/mision/back-btn-menu-2.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                      <div
                        class="desc d-flex justify-content-start align-items-center"
                      >
                        <div class="icono">
                          <img
                            src="../../../assets/imgs/mision/4/icono-3.png"
                            alt="Encauce"
                            class="img-fluid"
                          />
                        </div>
                        <div class="texto bold fpG blanco">
                          CONOCIMIENTO <br />03
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      active: avance.misiones[mision - 1].reto >= 4,
                      noevents: avance.misiones[mision - 1].reto < 4,
                      selected: selected == 4,
                    }"
                    class="opcion opcion-4 d-flex flex-row justify-content-center align-items-center"
                  >
                    <div class="bullet">
                      <img
                        src="../../../assets/imgs/mision/bullet.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div class="reto" @click="selecciona(4)">
                      <img
                        src="../../../assets/imgs/mision/back-btn-menu-2.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                      <div
                        class="desc d-flex justify-content-start align-items-center"
                      >
                        <div class="icono">
                          <img
                            src="../../../assets/imgs/mision/4/icono-4.png"
                            alt="Encauce"
                            class="img-fluid"
                          />
                        </div>
                        <div class="texto bold fpG blanco">
                          CONOCIMIENTO <br />04
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <router-link
              to="/progreso"
              class="miperfil abs pointer"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <img
                src="../../../assets/imgs/mision/btn-mi-perfil.png"
                alt="Encauce"
                class="img-fluid"
              />
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
    <OverlayInfo
      :info="info"
      :showInfo="showInfo"
      v-on:toggleInfoC="toggleInfo"
    ></OverlayInfo>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import OverlayInfo from "@/components/OverlayInfo";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../../router/index";

export default {
  components: {
    Footer,
    OverlayInfo,
    
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      mision: 4,
      selected: 1,
      showInfo: false,
      info: `
      <p>

Los Objetivos de Desarrollo Sostenible, también conocidos como Objetivos Mundiales, se adoptaron como un llamado universal para poner fin a la pobreza, proteger el planeta y garantizar que todas las personas gocen de paz y prosperidad.
</p>
<p>
Explora las distintas bases interestelares y selecciona en cual de ellas te gustaría colaborar. 
</p>
<p>
Estos Objetivos de Desarrollo tienen como meta el desarrollo sostenible de todas las personas incluyendo el progreso económico, social y tecnológico siempre respetando el planeta.
</p>

      `,
      extracto: `
Los Objetivos de Desarrollo Sostenible, también conocidos como Objetivos Mundiales...
        `,
      avance: {
        misiones: [],
      },
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.avance.personaje = localStorage.getItem("personaje");
    console.log(this.avance.personaje);

    this.getAvance();
  },
  methods: {
    toggleInfo() {
      this.showInfo = !this.showInfo;
    },
    async getAvance() {
      this.avance = await this.$store.dispatch("getAvance");
      console.log(this.avance);
    },
    selecciona(reto) {
      this.selected = reto;
    },
    avanzar() {
      router.push("/mision-" + this.mision + "-" + this.selected);
    },
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
$azul-icono: #84d8fa;
@mixin transition($property) {
  -webkit-transition: $property;
  -moz-transition: $property;
  -ms-transition: $property;
  -o-transition: $property;
  transition: $property;
}
#mision {
  background: url(../../../assets/imgs/mision/bg-seleccion.jpg) no-repeat;
  background-size: cover;
  background-position: bottom center;
  .contentabs {
    .logo {
      top: 2%;
      right: 5%;
      width: 10%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .personaje {
      bottom: 4%;
      left: 28%;
      width: 20%;
      position: absolute;
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
    }

    .botonera {
      width: 80%;
      margin: 0 10% 0 2%;
      top: 55%;
      transform: translateY(-50%);
      position: absolute;
      left: 13.5%;

      .planeta {
        width: 30.8%;
        top: 5%;
        left: -12.5%;
        .objetivo {
          position: relative;
          .texto {
            position: absolute;
            top: 1vw;
            padding: 1vw;
          }
        }
      }

      .holograma {
        bottom: 0%;
        position: relative;
        .info {
          position: absolute;
          top: 10%;
          left: 23%;
          width: 30%;
          text-align: center;
          .icono {
            width: 80%;
            animation: 2.5s float infinite;
          }
          .texto {
            line-height: 1;
          }
          .boton {
            width: 40%;
            cursor: pointer;
          }
        }
        .opciones {
          position: absolute;
          left: 50%;
          top: 0%;
          width: 40%;
          height: 100%;
          .opcion {
            position: absolute;
            width: 85%;
            opacity: 0.6;
            cursor: pointer;
            @include transition(0.25s all ease-out);
            .reto {
              position: relative;
              .desc {
                position: absolute;
                top: 0%;
                left: 3%;
                height: 100%;
                width: 100%;
                .icono {
                  width: 26%;
                  height: 80%;
                  padding: 2.5%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background: $azul-icono;
                  border-radius: 80%;
                  left: 0%;
                  position: relative;
                  img {
                    width: 70%;
                  }
                }
                .texto {
                  width: 60%;
                  text-align: center;
                  user-select: none;
                }
              }
            }
            &.active {
              opacity: 1;
            }
            &.selected {
              width: 100%;
              margin-top: -3%;
            }
          }
          .opcion-1 {
            top: 10%;
            left: 19%;
          }
          .opcion-2 {
            top: 30%;
            left: 36%;
          }
          .opcion-3 {
            top: 50%;
            left: 36%;
          }
          .opcion-4 {
            top: 70%;
            left: 19%;
          }
        }
      }

      .bgtitulo {
        width: 80%;
        margin: 0 10%;
        position: relative;
        .texto {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          left: 0px;
        }
      }
      .mision {
        width: 33.33%;
        position: relative;
        .planeta {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
        .planeta-lock {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
      }
    }

    .btn-avanzar {
      position: absolute;
      bottom: 2%;
      left: 65%;
    }

    @media (min-width: 993px) {
      .personaje {
        bottom: 4%;
        left: 25%;
        width: 25%;
      }
    }
  }
}
</style>
